module.exports = __webpack_public_path__ + "static/img/pd_logo_light.77adae0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pd_logo_light.png
// module id = dOZU
// module chunks = 1